import { render, staticRenderFns } from "./accountSetting.vue?vue&type=template&id=4d89b9a0&scoped=true&"
import script from "./accountSetting.vue?vue&type=script&lang=js&"
export * from "./accountSetting.vue?vue&type=script&lang=js&"
import style0 from "./accountSetting.vue?vue&type=style&index=0&id=4d89b9a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89b9a0",
  null
  
)

export default component.exports